import { RootState } from '../../';
import { NOTE_STATUS, REMINDER_AVAILABILITY } from '@ax/constants';
import { selectedVisitInitialStateValue } from './';

export const selectSelectedVisit = (state: RootState) =>
  state.selectedVisit || { ...selectedVisitInitialStateValue };
export const selectSelectedVisitUuid = (state: RootState) => selectSelectedVisit(state).uuid;
export const selectAreCareCuesAvailable = (state: RootState) =>
  selectSelectedVisit(state).reminderAvailability === REMINDER_AVAILABILITY.AVAILABLE;
export const selectAreCareCuesSeen = (state: RootState) =>
  selectSelectedVisit(state).reminderAvailability === REMINDER_AVAILABILITY.SEEN;
export const selectIsUploaded = (state: RootState) =>
  [NOTE_STATUS.NOTE_UPLOADED_TO_MDS, NOTE_STATUS.NOTE_UPLOADED_TO_EHR].includes(
    selectSelectedVisit(state).noteStatus,
  );
